// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Money24Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Money24: FC<Money24Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="24"
        >
            <path d="M11.025 21v-2.15a5.09 5.09 0 0 1-2.287-1.15c-.642-.567-1.113-1.367-1.413-2.4l1.85-.75c.25.8.62 1.408 1.112 1.825.492.417 1.138.625 1.938.625.683 0 1.263-.154 1.738-.462.475-.309.712-.788.712-1.438 0-.583-.183-1.046-.55-1.387-.367-.342-1.217-.73-2.55-1.163-1.433-.45-2.417-.988-2.95-1.613-.533-.624-.8-1.387-.8-2.287 0-1.083.35-1.925 1.05-2.525.7-.6 1.417-.942 2.15-1.025V3h2v2.1c.833.133 1.52.438 2.063.913a4.187 4.187 0 0 1 1.187 1.737l-1.85.8c-.2-.533-.483-.933-.85-1.2-.367-.267-.867-.4-1.5-.4-.733 0-1.292.162-1.675.487-.383.325-.575.73-.575 1.213 0 .55.25.983.75 1.3.5.317 1.367.65 2.6 1 1.15.333 2.02.863 2.612 1.588.592.724.888 1.562.888 2.512 0 1.183-.35 2.083-1.05 2.7-.7.617-1.567 1-2.6 1.15V21h-2Z" />
        </svg>
    );
};

export default Money24;
